import * as React from "react";
import { useNavigate } from "react-router-dom";
import { nameOfKind, pluralNameOfKind } from "../../../services/cpln";
import { useAppSelector } from "../../../store/hooks";
import { selectContext } from "../../../store/contextSlice";
import { Button } from "antd";
import { Lock } from "react-feather";

interface Props {
  kind: string;
}
export const AccessRestrictedItem: React.FC<Props> = ({ kind }) => {
  const { org } = useAppSelector(selectContext);
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col items-center py-16 border rounded-lg">
      <Lock size={30} className="color-label" />
      <div className="mt-2 mb-6 text-lg">You don't have permission to access this {nameOfKind(kind)}.</div>
      <div className="flex items-center">
        <Button
          onClick={() => {
            navigate(`/console${`/org/${org}/${kind}`}`);
          }}
          type={"primary"}
        >
          Go to {pluralNameOfKind(kind)}
        </Button>
      </div>
    </div>
  );
};
